import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useContext, useMemo, useImperativeHandle } from 'react';
import { MultiViewRootContext } from './contexts.js';
import ParentedView from './internal/ParentedView.js';
import SingleView from './internal/SingleView.js';

var View = forwardRef(function View(props, fwdRef) {
    const singleViewRef = useRef(null);
    const parentedViewRef = useRef(null);
    const multiViewRoot = useContext(MultiViewRootContext);
    const api = useMemo(() => {
        const getView = () => multiViewRoot ? parentedViewRef.current : singleViewRef.current;
        return {
            isInMultiViewRoot: () => multiViewRoot,
            isMounted: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.isMounted()) !== null && _b !== void 0 ? _b : false; },
            getViewContainer: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.getViewContainer()) !== null && _b !== void 0 ? _b : null; },
            getOpenGLRenderWindow: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.getOpenGLRenderWindow()) !== null && _b !== void 0 ? _b : null; },
            getRenderWindow: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.getRenderWindow()) !== null && _b !== void 0 ? _b : null; },
            getRenderer: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.getRenderer()) !== null && _b !== void 0 ? _b : null; },
            getInteractorStyle: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.getInteractorStyle()) !== null && _b !== void 0 ? _b : null; },
            setInteractorStyle: (style) => { var _a; return (_a = getView()) === null || _a === void 0 ? void 0 : _a.setInteractorStyle(style); },
            requestRender: () => { var _a; return (_a = getView()) === null || _a === void 0 ? void 0 : _a.requestRender(); },
            getCamera: () => { var _a, _b; return (_b = (_a = getView()) === null || _a === void 0 ? void 0 : _a.getCamera()) !== null && _b !== void 0 ? _b : null; },
            resetCamera: (boundsToUse) => { var _a; return (_a = getView()) === null || _a === void 0 ? void 0 : _a.resetCamera(boundsToUse); },
        };
    }, [multiViewRoot]);
    useImperativeHandle(fwdRef, () => api);
    if (multiViewRoot) {
        return jsx(ParentedView, Object.assign({}, props, { ref: parentedViewRef }));
    }
    else {
        return jsx(SingleView, Object.assign({}, props, { ref: singleViewRef }));
    }
});

export { View as default };
